import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const marketTabListCss = ":host([size='large']) ::slotted(.market-tab){font-weight:var(--core-type-heading-30-weight);font-size:var(--core-type-heading-30-size);font-family:var(--core-type-heading-30-font-family);line-height:var(--core-type-heading-30-leading);letter-spacing:var(--core-type-heading-30-tracking);text-transform:var(--core-type-heading-30-case)}:host([size='small']) ::slotted(.market-tab){font-weight:var(--core-type-heading-20-weight);font-size:var(--core-type-heading-20-size);font-family:var(--core-type-heading-20-font-family);line-height:var(--core-type-heading-20-leading);letter-spacing:var(--core-type-heading-20-tracking);text-transform:var(--core-type-heading-20-case)}:host{display:flex;box-shadow:inset 0 -1px 0 var(--header-divider-color)}:host([size='small']){gap:16px}:host([size='large']){gap:24px}:host([size='small']) ::slotted(.market-tab){padding:4px 0 8px}:host([size='large']) ::slotted(.market-tab){padding:4px 0 10px}";

const MarketTabList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketTabSelectionDidChange = createEvent(this, "marketTabSelectionDidChange", 7);
    this.defaultSelected = undefined;
    this.size = 'small';
  }
  getInitiallySelectedTab() {
    return (this.defaultSelected ? this.el.querySelector(`#${this.defaultSelected}`) : this.el.children[0]);
  }
  componentDidLoad() {
    const selectedTab = this.getInitiallySelectedTab();
    selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.select();
  }
  /**
   * Listen for the marketTabSelected event which is fired when a market-tab is selected
   */
  async marketTabSelectedEventHandler(e) {
    var _a, _b;
    const newSelection = e.target;
    const oldSelection = this.el.querySelector(`${getNamespacedTagFor('market-tab')}[aria-selected="true"]`);
    oldSelection === null || oldSelection === void 0 ? void 0 : oldSelection.setAttribute('aria-selected', 'false');
    oldSelection === null || oldSelection === void 0 ? void 0 : oldSelection.setAttribute('tabindex', '-1');
    newSelection.setAttribute('aria-selected', 'true');
    newSelection.setAttribute('tabindex', '0');
    const event = this.marketTabSelectionDidChange.emit({
      selectedTab: newSelection,
      deselectedTab: oldSelection,
    });
    if (!event.defaultPrevented) {
      (_a = (await newSelection.getAssociatedPanel())) === null || _a === void 0 ? void 0 : _a.show();
      (_b = (await (oldSelection === null || oldSelection === void 0 ? void 0 : oldSelection.getAssociatedPanel()))) === null || _b === void 0 ? void 0 : _b.hide();
    }
  }
  render() {
    return (h(Host, { class: "market-tab-list", role: "tablist" }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
MarketTabList.style = marketTabListCss;

export { MarketTabList as market_tab_list };
